import { FC, useState } from "react";
import { IChequeKizReportDTO, IChequeReport, IKizReport } from "../../../../../libs/coreapi-dto/accounting/cashSession";
import { BaseModalWindow } from "../../../../../components/modalWindows/BaseModalWindow";
import modalStyles from "../../../../../components/modalWindows/styles/BaseModalWindow.module.scss";
import { CashSessionDataProvider } from "../../../../../Services/DataProviders/CashSessionDataProvider";
import { useAppContext } from "../../../../../system/providers/appContextProvider";
import TableReportStatusKiz from "./TableReportStatusKiz";

export interface IModalReportStatusKiz {
    idReports: string;
    reports: IChequeReport[];
    cancel: () => void;
    ok: () => void;    
}

interface IReportItem {
    chequeNumber: string;
    idChequeGlobal: string;
    recipeNumber: string;
    kizReports: IKizReport[];
}

export const ModalReportStatusKiz: FC<IModalReportStatusKiz> = (props) => {
    const appContext = useAppContext() 
    const cdp = new CashSessionDataProvider(appContext.coreApiService);
   
    const [dataSchemeToReport, setDataSchemeToReport] = useState<IChequeKizReportDTO | null>(null);

    const handleDataChange = (data: IChequeKizReportDTO) => {
        setDataSchemeToReport(data);       
    };

    const prepareGridData = (data: IChequeKizReportDTO[] | IReportItem[]) => {
        
        const normalizedData = Array.isArray(data)
            ? data.flatMap(item => 
                'reports' in item 
                    ? item.reports 
                    : [{
                        chequeNumber: item.chequeNumber,
                        idChequeGlobal: item.idChequeGlobal,
                        recipeNumber: item.recipeNumber,
                        kizReports: item.kizReports
                    }]
              )
            : [];    
        
        if (normalizedData.length === 0) {
            console.warn('No valid data found');
            return [];
        }    
        
        return normalizedData.flatMap(report => 
            (report.kizReports || []).map(kizReport => ({
                chequeNumber: report.chequeNumber || '',
                recipeNumber: report.recipeNumber || '',
                gtinSgtin: kizReport.gtinSgtin || '',
                localKizState: kizReport.localKizState || '',
                kizStateIS: kizReport.kizStateIS ?? null,
                schemeType: kizReport.schemeType ?? 0,
                isSending: kizReport.isSending ?? null,
                idChequeGlobal: report.idChequeGlobal || '',
            }))
        );
    };

    const data = prepareGridData(props.reports)
    
    return (
        <BaseModalWindow
            header="Отчет по статусам"
            ok={{
                onClick: async () => {
                    if (dataSchemeToReport) {
                        try {
                            await cdp.getSchemeToReport(dataSchemeToReport, e => {
                                console.log(e)
                            });
                            props.ok();
                            props.cancel()
                        } catch (error) {
                            console.error('Ошибка отправки:', error);
                        }
                    }                                         
                },
                title: "Отправить",
                disabled: !dataSchemeToReport || dataSchemeToReport.reports.length === 0
            }}
            cancel={{ onClick: props.cancel }}
            modalWindowClassName={modalStyles.modalReportStatusKiz}
            footerStyle="confirm"
        >
            <TableReportStatusKiz
                idReports={props.idReports}                
                data={data}
                onDataChange={handleDataChange}
            />           
        </BaseModalWindow>
    )
}